import "core-js/modules/es.array.reduce.js";

/**
 * mixins of renderers
 */
import { isCalculated, getDefaultValue } from '../utils/widgetUtils';
import { formatValue } from './dataType'; // import Parser from '@components/formular-editor/parser'
// import { create } from '@/components/formular-editor/runner'
// const parser = new Parser()

export const ItemMixin = {
  props: {
    element: Object,
    // formValue: Function,
    value: {
      type: null,

      default() {
        return getDefaultValue(this.element);
      }

    },
    inline: Boolean,
    labelValue: Function,
    formData: Object,
    cols: Number,
    valueFormatter: Function
  },
  computed: {
    itemProps() {
      const {
        options
      } = this.element;
      const {
        defaultOptions
      } = this;
      const {
        required,
        ...other
      } = options;
      return { ...defaultOptions,
        ...other
      };
    },

    defaultOptions() {
      const {
        config
      } = this.componentCls.meta;

      if (!config || config.length === 0) {
        return {};
      }

      return config.reduce((ret, item) => {
        const {
          options
        } = item;

        if (options.default) {
          ret[options.name] = options.default;
        }

        return ret;
      }, {});
    },

    dataType() {
      const {
        options
      } = this.element;
      return options.dataType;
    },

    labelText() {
      const {
        element
      } = this;
      return element.options.showLabel === false ? '' : element.options.label;
    },

    readonly() {
      return this.element.options && this.element.options.readonly || isCalculated(this.element);
    },

    // 有的控件值可能是用表达式进行计算得到的
    calculatedValue() {
      // if (isCalculated(this.element)) {
      //   const formular = this.element.options.defaultVal[1]
      //   parser.setInput(formular)
      //   if (!parser.validate()) {
      //     console.error('无效的表达式', formular)
      //     return undefined
      //   }
      //   const run = create(parser.genCode())
      //   let result = run(this.labelValue)
      //   if (isNaN(result)) {
      //     return undefined
      //   }
      //   result = this.formatValue(result)
      //   if (result !== this.value) {
      //     this.handleInput(result)
      //   }
      //   return result
      // }
      return this.value;
    }

  },
  methods: {
    formatValue(val, format) {
      const {
        options,
        dataType
      } = this.element;
      const {
        valueFormatter
      } = this;

      if (valueFormatter) {
        const formated = valueFormatter(val, dataType, format || options.format);

        if (formated !== undefined) {
          return formated;
        }
      }

      return formatValue(val, dataType, format || options.format);
    },

    handleInput(val) {
      const {
        componentCls
      } = this;
      const {
        options
      } = this.element;
      const {
        valueFormat
      } = this.itemProps; // console.log('valueFormat', this.itemProps, valueFormat)

      const multiple = componentCls && componentCls.meta && componentCls.meta.multiple;
      this.$emit('change', options.name, this.formatValue(val, valueFormat), multiple);
    }

  }
};
export const FormMixin = {
  computed: {
    // 标签与值的对应关系，计算表达式使用
    labelValue() {
      const {
        schema,
        value
      } = this;

      if (!schema.children) {
        return {};
      }

      return schema.children.reduce((ret, item) => ({ ...ret,
        [item.options.label]: value[item.options.name]
      }), {});
    }

  },
  methods: {
    validate(...args) {
      return this.$refs.form.validate(...args);
    },

    getFormValue(label) {
      return this.labelValue[label];
    }

  }
};